/**
 * Hook for toggling boolean fields with error handling
 * Consolidates toggle logic used across detail views
 *
 * @param {object} item - The item containing the field to toggle
 * @param {string} fieldName - Name of the boolean field to toggle (camelCase)
 * @param {Function} onUpdate - Callback to update the item
 * @param {string} errorMessage - Optional custom error message
 * @returns {Function} handleToggle - Function to toggle the field
 */
export function useToggleField(item, fieldName, onUpdate, errorMessage = 'Failed to toggle field') {
  const handleToggle = async () => {
    try {
      const currentValue = item?.[fieldName];
      const newValue = !currentValue;

      // Convert camelCase to snake_case for API
      const apiFieldName = fieldName.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

      await onUpdate?.({ [apiFieldName]: newValue });
    } catch (error) {
      console.error(`${errorMessage}:`, error);
      alert(errorMessage);
    }
  };

  return handleToggle;
}
